import { Component, OnInit } from '@angular/core';
import { PaymentProfileCount } from '../../../models/payment-profile-count.model';
import { PaymentProfilesServices } from '../../services/payment-profiles.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-payment-profiles-count',
  templateUrl: './payment-profiles-count.component.html',
  styleUrls: ['./payment-profiles-count.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class PaymentProfilesCountComponent implements OnInit {
  paymentProfileCount!: PaymentProfileCount;
  loading = false;

  constructor(private paymentProfilesServices: PaymentProfilesServices) {}

  ngOnInit() {
    this.loading = true;
    this.getPaymentProfileCount();
  }

  getPaymentProfileCount() {
    this.paymentProfilesServices
      .getPaymentProfileCount()
      .subscribe(paymentProfileCount => {
        this.paymentProfileCount = paymentProfileCount;
        this.loading = false;
      });
  }
}
